import { render } from "./CustomizeProductButton.vue?vue&type=template&id=71988a8a&scoped=true"
import script from "./CustomizeProductButton.vue?vue&type=script&lang=js"
export * from "./CustomizeProductButton.vue?vue&type=script&lang=js"

import "./CustomizeProductButton.vue?vue&type=style&index=0&id=71988a8a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71988a8a"]])

export default __exports__